
export const BACKGROUND_COMPONENT_CLASSNAME = "backgroundComponent";